import { Features } from "./IRootState";

export function isFeatureEnabled({
  feature,
  featureFlags,
  defaultEnabled = true,
}: {
  feature: keyof Features;
  featureFlags: Features | null | undefined;
  /* By default feature flags must be defined as false to disable a feature,
   * but that can be switched by specifically setting defaultEnabled to false,
   * in which case missing flag -> disabled feature. */
  defaultEnabled?: boolean;
}): boolean {
  const flagValue = featureFlags?.[feature];
  const isFlagSet = flagValue !== null && flagValue !== undefined;
  return isFlagSet ? !!flagValue : defaultEnabled;
}
